import React from 'react';
import { CloudNodeIcon } from '../components/IndustryIcons';
import { FocalQuote, Metric, Panel, SectionFrame } from '../components/SectionFrame';
const scorecard = [{
  value: '$100M+',
  label: 'Enterprise Value Created',
  detail: 'Realized across the full STRIDE portfolio.'
}, {
  value: '18',
  label: 'Strategic Initiatives',
  detail: 'AI, cloud, workforce, and application rationalization.'
}, {
  value: '34%',
  label: 'Application Footprint Cut',
  detail: '630 applications reduced to 414.'
}, {
  value: '$11M',
  label: 'Recurring Annual Reduction',
  detail: 'Workforce, vendor, insurance, and operating model.'
}];
const ledger = [{
  title: 'STRIDE Portfolio Architecture — Strategic Technology Reinvention and Innovation for a Digital Enterprise',
  body: 'Directed an 18-initiative transformation spanning artificial intelligence, cybersecurity, cloud modernization, workforce realignment, application rationalization, and operational technology — aligning every technology dollar to a stated business objective and an owner accountable for the result.'
}, {
  title: 'Application Rationalization',
  body: 'Reduced the enterprise application portfolio by 34%, from 630 to 414 applications, unlocking $11M in recurring annual cost reductions while removing the technical debt and vulnerability surface that a sprawling portfolio carries with it.'
}, {
  title: 'SAP ERP & Customer Revenue Billing',
  body: 'Redesigned the SAP ERP and Customer Revenue Billing modernization strategy, capturing roughly $20M in near-term savings and avoiding $80M+ in lifecycle costs — a sequencing decision made before the spend, not a recovery after it.'
}];
export function Stride() {
  return <SectionFrame index="03" eyebrow="Realized Enterprise Value" headline="The STRIDE Playbook: Driving $100M+ in Enterprise Value" subheadline="STRIDE — Strategic Technology Reinvention and Innovation for a Digital Enterprise — was built from nothing into the enterprise's transformation operating system. This is its scorecard: what was committed, what was banked, and what was avoided." data-id="element-297" data-mp="2s2p4xo3150rf">
      <div className="grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-298" data-mp="3e0jstqzlaffe">
        {scorecard.map(m => <Metric key={m.label} {...m} data-id="element-299" data-mp="3nsfpcxm11xhi" />)}
      </div>

      <div className="mt-10 grid gap-6 lg:grid-cols-[1.6fr_1fr]" data-id="element-300" data-mp="3nu0iqjwlvads">
        <Panel className="p-7 sm:p-9" data-id="element-301" data-mp="3ssah13dmmr3m">
          <h2 className="display text-2xl font-black text-steel-dark" data-id="element-302" data-mp="3sr96d00iw6mf">Where the value came from</h2>
          <dl className="mt-6 divide-y divide-panel-deep" data-id="element-303" data-mp="lwwve6ev2vj">
            {ledger.map(item => <div key={item.title} className="py-5 first:pt-0 last:pb-0" data-id="element-304" data-mp="5nm6qqhwdai1">
                <dt className="display text-lg font-black text-hydro" data-id="element-305" data-mp="akl19a5h3jgr">{item.title}</dt>
                <dd className="mt-2 text-[15px] leading-relaxed text-steel-dark/85" data-id="element-306" data-mp="27ez855knp09c">{item.body}</dd>
              </div>)}
          </dl>
        </Panel>

        <Panel tone="steel" className="flex flex-col p-7 sm:p-9" data-id="element-307" data-mp="24trj00lbb6xc">
          <CloudNodeIcon className="h-9 w-9 text-copper-light" data-id="element-308" data-mp="24v2ny3qhukq1" />
          <h2 className="display mt-5 text-2xl font-black text-panel" data-id="element-309" data-mp="202rlat4dckts">Cost Avoided vs. Cost Cut</h2>
          <p className="mt-3 text-[15px] leading-relaxed text-panel/75" data-id="element-310" data-mp="1v357oikmp2kg">
            Two different governance conversations. Savings show up in the next rate case; avoidance shows up in the
            decade after it.
          </p>
          <div className="mt-7 space-y-6" data-id="element-311" data-mp="2nruemy8d8244">
            <div data-id="element-312" data-mp="2itsmlnsyosgi">
              <p className="tabular display text-4xl font-black text-panel" data-id="element-313" data-mp="2it9eeyt45ifo">~$20M</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-copper-light" data-id="element-314" data-mp="2dtwr6cyby9ck">
                Near-term savings captured
              </p>
            </div>
            <div className="border-t border-white/10 pt-6" data-id="element-315" data-mp="12f9dplmg1ord">
              <p className="tabular display text-4xl font-black text-panel" data-id="element-316" data-mp="12gkk7t79xam6">$80M+</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-copper-light" data-id="element-317" data-mp="xfes9xlftrdp">
                Lifecycle cost avoided
              </p>
            </div>
          </div>
          <p className="mt-auto pt-7 text-sm leading-relaxed text-panel/60" data-id="element-318" data-mp="2r1voyrpw08oa">
            Both figures originate from a single re-sequencing decision on the ERP and billing roadmap.
          </p>
        </Panel>
      </div>

      <FocalQuote data-id="element-319" data-mp="2hbk6m05ghwxv">
        Transformational value is realized when technology strategy directly reinforces financial discipline and
        operational performance.
      </FocalQuote>
    </SectionFrame>;
}